import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { CONTACT_INFO } from "../data";

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  // Close mobile menu on route change
  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  const activeClass = ({ isActive }) =>
    `text-xs min-[1200px]:text-sm font-extrabold uppercase tracking-widest transition-colors duration-200 ${
      isActive ? "text-brand-orange" : "text-white/80 hover:text-white"
    }`;

  const mobileActiveClass = ({ isActive }) =>
    `block py-3 px-4 text-sm font-extrabold uppercase tracking-widest transition-colors ${
      isActive ? "bg-zinc-800 text-brand-orange" : "text-white/80 hover:bg-zinc-800 hover:text-white"
    }`;

  return (
    <header className="absolute top-0 left-0 w-full z-40 bg-transparent">
      {/* 1. Utility Top Bar */}
      <div className="hidden md:block bg-zinc-950/95 text-white py-3 px-4 md:px-12 border-b border-white/10">
        <div className="mx-auto max-w-7xl flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-xs">
          {/* Left Side: Contact Items */}
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <a
              href={`tel:+45${CONTACT_INFO.phone}`}
              className="flex items-center gap-2 hover:text-brand-orange transition-colors font-bold tracking-wider"
            >
              <i className="fa-solid fa-phone text-brand-orange" aria-hidden="true"></i>
              <span>TLF: {CONTACT_INFO.phone}</span>
            </a>
            <a
              href={`mailto:${CONTACT_INFO.email}`}
              className="flex items-center gap-2 hover:text-brand-orange transition-colors font-bold tracking-wider"
            >
              <i className="fa-solid fa-envelope text-brand-orange" aria-hidden="true"></i>
              <span>{CONTACT_INFO.email}</span>
            </a>
          </div>
          {/* Right Side: Solid Call-to-Action Block */}
          <div className="flex items-center">
            <a
              href={`tel:+45${CONTACT_INFO.phone}`}
              className="bg-neutral-800 hover:bg-brand-orange px-5 py-2 text-white font-extrabold uppercase tracking-widest text-[10px] sm:text-xs rounded-full transition-colors duration-200"
            >
              RING {CONTACT_INFO.phone}
            </a>
          </div>
        </div>
      </div>

      {/* 2. Main Navigation Header */}
      <div className="mx-auto max-w-7xl px-4 md:px-12 py-6">
        <div className="flex items-center justify-between">
          {/* Brand Logo */}
          <Link to="/" className="flex items-center group focus:outline-none">
            <span className="text-lg md:text-2xl font-extrabold tracking-widest text-white uppercase transition-colors group-hover:text-brand-orange">
              Halsnæs Epoxygulve
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden min-[1200px]:flex items-center gap-8">
            <NavLink to="/" className={activeClass}>
              Forside
            </NavLink>
            <NavLink to="/flydemoertel" className={activeClass}>
              Flydemørtel
            </NavLink>
            <NavLink to="/kvartsgulve" className={activeClass}>
              Kvartsgulve
            </NavLink>
            <NavLink to="/epoxygulve" className={activeClass}>
              Epoxygulve
            </NavLink>
            <NavLink to="/kontakt" className={activeClass}>
              Kontakt
            </NavLink>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="min-[1200px]:hidden flex h-10 w-10 items-center justify-center text-white hover:text-brand-orange focus:outline-none transition-colors"
            aria-label={isOpen ? "Luk menu" : "Åben menu"}
          >
            <i className={`fa-solid ${isOpen ? "fa-xmark" : "fa-bars"} text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* 3. Mobile Navigation Drawer */}
      {isOpen && (
        <div className="min-[1200px]:hidden bg-zinc-950/95 border-b border-white/10 py-4 px-2 shadow-xl animate-in slide-in-from-top duration-200">
          <nav className="space-y-1">
            <NavLink to="/" className={mobileActiveClass}>
              Forside
            </NavLink>
            <NavLink to="/flydemoertel" className={mobileActiveClass}>
              Flydemørtel
            </NavLink>
            <NavLink to="/kvartsgulve" className={mobileActiveClass}>
              Kvartsgulve
            </NavLink>
            <NavLink to="/epoxygulve" className={mobileActiveClass}>
              Epoxygulve
            </NavLink>
            <NavLink to="/kontakt" className={mobileActiveClass}>
              Kontakt
            </NavLink>
          </nav>
        </div>
      )}
    </header>
  );
}
